// src/components/Navbar.js
import React, { useEffect, useMemo, useState } from 'react';

export default function Navbar() {
  const navItems = useMemo(
    () => [
      { id: 'home', label: 'Home' },
      { id: 'about', label: 'About Us' },
      { id: 'memberships', label: 'Meberships' },
      { id: 'classes', label: 'Classes' },
      { id: 'facilities', label: 'Facilities' },
    ],
    []
  );
  const [activeSection, setActiveSection] = useState('home');

  const linkClass = (active) => `nav-link ${active ? 'active' : ''}`;

  const hideMobileMenu = (force = false) => {
    const isMobile = window.matchMedia('(max-width: 991.98px)').matches;
    if (!force && !isMobile) return;

    const el = document.getElementById('navbarNav');
    if (!el) return;
    if (!window.bootstrap || !window.bootstrap.Collapse) return;
    const instance = window.bootstrap.Collapse.getInstance
      ? window.bootstrap.Collapse.getInstance(el)
      : null;
    if (instance && instance.hide) {
      instance.hide();
      return;
    }

    // Fallback for Bootstrap versions without getInstance()
    const created = new window.bootstrap.Collapse(el, { toggle: false });
    created.hide?.();
  };

  const handleLinkClick = (sectionId) => {
    setActiveSection(sectionId);
    hideMobileMenu(true);
  };

  useEffect(() => {
    const sections = navItems
      .map((item) => document.getElementById(item.id))
      .filter(Boolean);

    if (!sections.length) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

        if (visible[0]?.target?.id) {
          setActiveSection(visible[0].target.id);
        }
      },
      {
        threshold: [0.25, 0.5, 0.75],
        rootMargin: '-20% 0px -35% 0px',
      }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, [navItems]);

  // IntersectionObserver handles which section is active on the main page.

  return (
    <nav className="navbar navbar-expand-md navbar-dark navbar-gym py-2 py-md-2">
      <div className="container">
        <a href="#home" className="navbar-brand fw-bold" onClick={() => handleLinkClick('home')}>
          Quantum Gym
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse navbar-collapse-mobile" id="navbarNav">
          <div className="d-flex justify-content-end d-md-none px-3 pb-2">
            <button
              type="button"
              className="btn-close btn-close-white navbar-close-mobile"
              aria-label="Close menu"
              onClick={hideMobileMenu}
            />
          </div>
          <ul className="navbar-nav ms-auto mb-2 mb-md-0 gap-2 gap-md-3 w-100 justify-content-center">
            <li className="nav-item text-center">
              <a
                href="#home"
                className={linkClass(activeSection === 'home')}
                onClick={() => handleLinkClick('home')}
              >
                Home
              </a>
            </li>
            <li className="nav-item text-center">
              <a
                href="#about"
                className={linkClass(activeSection === 'about')}
                onClick={() => handleLinkClick('about')}
              >
                About Us
              </a>
            </li>
            <li className="nav-item text-center">
              <a
                href="#memberships"
                className={linkClass(activeSection === 'memberships')}
                onClick={() => handleLinkClick('memberships')}
              >
                Meberships
              </a>
            </li>

            <li className="nav-item text-center">
              <a
                href="#classes"
                className={linkClass(activeSection === 'classes')}
                onClick={() => handleLinkClick('classes')}
              >
                Classes
              </a>
            </li>

            <li className="nav-item text-center">
              <a
                href="#facilities"
                className={linkClass(activeSection === 'facilities')}
                onClick={() => handleLinkClick('facilities')}
              >
                Facilities
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
